import { Image } from "@/components/image";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Icon } from "@/components/icon";
import { OnboardingStepper } from "@/ui/onboarding-stepper";
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useRouter } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { logout as logoutHandler } from "@/handlers/logout";
import { commitLocalUpdate, useRelayEnvironment } from "react-relay";

export const Route = createFileRoute("/_logged/onboarding")({
	component: RouteComponent,
	head: () => {
		return {
			meta: [
				{
					name: "robots",
					content: "noindex,nofollow",
				},
			],
		};
	},
});

function RouteComponent() {
	const environment = useRelayEnvironment();
	const navigate = useNavigate({ from: Route.fullPath });
	const router = useRouter();
	const logout = useServerFn(logoutHandler);

	return (
		<div className="bg-background h-screen w-screen font-sans overflow-x-hidden">
			<div className="h-16 border border-sidebar-border px-6 bg-sidebar text-sidebar-foreground grid gap-6 grid-cols-3 w-full">
				<div className="flex items-center justify-start">
					<Image
						src="https://storage.googleapis.com/scarf-club-assets/logos/Scarf-Full-Primary.svg"
						className="h-7 w-fit"
						height={240}
					/>
				</div>

				<OnboardingStepper />

				<div className="flex items-center justify-end">
					<DropdownMenu>
						<DropdownMenuTrigger>
							<Avatar className="border cursor-pointer">
								<AvatarFallback>TH</AvatarFallback>
							</Avatar>
						</DropdownMenuTrigger>
						<DropdownMenuContent align="end">
							<DropdownMenuItem
								onClick={async () => {
									if (confirm("Tem certeza que deseja fazer logout?")) {
										logout().then(async () => {
											commitLocalUpdate(environment, (store) =>
												store.invalidateStore(),
											);

											router.invalidate();

											navigate({
												reloadDocument: true,
											});
										});
									}
								}}
							>
								<Icon name="LogOut" className="size-4" />
								Logout
							</DropdownMenuItem>
						</DropdownMenuContent>
					</DropdownMenu>
				</div>
			</div>

			<Outlet />
		</div>
	);
}
